<template>
<div id="qusetiontype-edit">
  <div class="iv-text iv-fc-85"
  v-show="!isShow || (isShow&&!show)"
  @click="show = true"
  v-text="item.userAnswer || !item.userAnswer == '' ?  item.userAnswer : '                           '">
  </div>
  <Input v-show="isShow&&show" @on-blur="show = false" v-model="item.userAnswer" placeholder="请输入您的答案" style="width: 343px"></Input>
</div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    id: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      show: false
    }
  },
  watch: {
    id () {
      if (this.id.indexOf(this.item.optionOrder) > -1) this.show = true
    }
  },
  computed: {
    isShow () {
      return this.id.indexOf(this.item.optionOrder) > -1
    }
  }
}
</script>
<style lang="scss" scoped>
.iv-text{
  min-width: 343px;
  max-width: 100%;
  white-space: pre-wrap;
  word-wrap: break-word;
  text-decoration: underline;
  padding-left: 16px;
}
</style>
<style lang="scss">
#qusetiontype-edit{
  .ivu-input{
    margin-top:7px;
    margin-left:16px;
  }
  // .iv-userAnswer{
  // }
}
</style>
